module.exports = __webpack_public_path__ + "assets/img/xsyl_title.d86068ae.png";